import styled, { css } from 'styled-components';

export const StyledDropDown = styled.div``;

export const StyledDropDownWrapper = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s;
  
   ${props => props.isExpanded && css`
     max-height: ${props => props.wrapperHeight}px;
  `};
`;
